export default {
  getOpenedModals (state) {
    return state.openedModals
  }
}